// utils/slug.ts

/**
 * slugify: usato per i PRODOTTI
 * Risultato:
 * - minuscolo
 * - solo lettere e numeri
 * - trattini come separatori
 * Esempio: "Uova Omega 3 Fresche" → "uova-omega-3-fresche"
 */
export function slugify(input: string): string {
  return (input || "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "") // rimuove accenti
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")     // tutto ciò che non è a-z0-9 diventa "-"
    .replace(/^-+|-+$/g, "");        // rimuove trattini ai bordi
}

/**
 * compactSlug: usato per gli SHOP
 * Risultato:
 * - minuscolo
 * - solo lettere e numeri
 * - nessun separatore
 * Esempio: "Avicola del Sole" → "avicoladelsole"
 */
export function compactSlug(input: string): string {
  return (input || "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "") // rimuove accenti
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");      // elimina tutto ciò che non è a-z0-9
}
